var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { StatusCode } from "../http/ajax/statusCode";
import { toSingleString } from "./strings";
var NoFieldError = {
    errors: null,
    evaluate: null
};
var NoEntityError = {};
var Entity = "";
function isFieldErrorsValid(field) {
    if (field.evaluate === false) {
        return true;
    }
    var messages = field.errors;
    if (!Array.isArray(messages)) {
        return messages === null;
    }
    else if (messages.length === 0) {
        return true;
    }
    else if (messages.length === 1) {
        return messages[0] === null;
    }
    else {
        return false;
    }
}
function getFieldErrorsAsString(state, field) {
    var _a;
    return state.errors ? toSingleString((_a = state.errors[field]) === null || _a === void 0 ? void 0 : _a.errors) : null;
}
function getCollectionErrorsAsString(state, field) {
    var _a;
    return state.errors ? toSingleString((_a = state.errors[field]) === null || _a === void 0 ? void 0 : _a.errors) : null;
}
function isEntityErrorsValid(errors) {
    return Object.entries(errors).every(function (item) { return isFieldErrorsValid(item[1]); });
}
function updateByResponseTemp(draft, response) {
    if (response.succeeded) {
        //draft.entity = response.data.entity as E;
        draft.entity = response.data;
        clearErrors(draft);
    }
    else {
        updateErrorsFromResponse(draft, response);
    }
}
function updateByEntityResponse(draft, response) {
    var entityResponse = response.data;
    if (response.succeeded) {
        if (entityResponse != null) {
            draft.entity = entityResponse.entity;
        }
        clearErrors(draft);
    }
    if (entityResponse != null && entityResponse.errors != null) {
        validationErrorsToEntityErrors(draft, entityResponse.errors, true);
    }
    else if (!response.succeeded) {
        responseErrorToEntityError(draft, response.status, true);
    }
}
function updateErrorsByEntityResponse(draft, response) {
    var entityResponse = response.data;
    if (entityResponse != null && entityResponse.errors != null) {
        validationErrorsToEntityErrors(draft, entityResponse.errors, true);
    }
    else if (!response.succeeded) {
        responseErrorToEntityError(draft, response.status, true);
    }
}
function updateErrorsFromResponse(draft, response) {
    if (response.succeeded) {
        clearErrors(draft);
        return;
    }
    var data = response.data;
    if (data == null || data["ValidationErrors"] == null) {
        responseErrorToEntityError(draft, response.status, true);
    }
    else {
        validationErrorsToEntityErrors(draft, data["ValidationErrors"], true);
    }
}
function clearErrors(draft) {
    draft.errors = __assign({}, NoEntityError);
}
function responseErrorToEntityError(draft, status, clearExisting) {
    var message;
    switch (status) {
        case StatusCode.Unauthorized:
            message = "Nemáte oprávnění k provedení akce.";
            break;
        case StatusCode.NotFound:
            message = "Zdroj nenalezen.";
            break;
        case StatusCode.BadRequest:
            message = "Chybný požadavek.";
            break;
        case StatusCode.InternalServerError:
            message = "Interní chyba serveru.";
            break;
        default:
            message = status.toString(); // TODO something user friendly
            break;
    }
    errorToEntityError(draft, message, clearExisting);
}
function errorToEntityError(draft, message, clearExisting, entityField) {
    if (entityField === void 0) { entityField = Entity; }
    var errors = clearExisting ? __assign({}, NoEntityError) :
        draft.errors;
    errors[entityField] = {
        errors: message,
        evaluate: null
    };
    draft.errors = errors;
}
function validationErrorsToEntityErrors(draft, validationErrors, clearExisting) {
    var errors = clearExisting ? __assign({}, NoEntityError) : draft.errors;
    for (var _i = 0, _a = Object.entries(validationErrors); _i < _a.length; _i++) {
        var validationError = _a[_i];
        errors[validationError[0]] = {
            errors: validationError[1].errors,
            evaluate: null
        };
    }
    draft.errors = errors;
}
export { Entity as WholeEntityError, errorToEntityError, getFieldErrorsAsString, getCollectionErrorsAsString, isEntityErrorsValid, isFieldErrorsValid, NoEntityError, NoFieldError, updateByEntityResponse, updateByResponseTemp, updateErrorsByEntityResponse, updateErrorsFromResponse };
